<template>

    <div class="main">
        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;"> Leads </h3>
                <div>
                    <a-button @click="createLeadUrl" style="border-raduis:6px; background: #fff;color:#0F3659"
                        icon="plus">
                        Add New Lead
                    </a-button>
                    <a-button class="ml-4" :loading="loading" @click="exportExcell"
                        style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div>
            </div>
            <div class="card-container mt-5">
                <all-leads-table :leads="lead"></all-leads-table>
            </div>
        </a-card>
    </div>
</template>

<script>

import moment from 'moment';
// import _ from 'lodash';
import XLSX from "xlsx";
import { mapActions } from 'vuex';

import { NotificationMixins } from '@/mixins/NotificationMixins'
import AllLeadsTable from './tables/AllLeadsTable.vue'

export default {
    name: "Leads",
    components: {
        AllLeadsTable,
    },
    data() {
        return {
            tableSalesFullfillments: [],
            tableBackordersFullfillments: [],
            loading: false,
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            lead: {}
        }
    },
    mixins: [NotificationMixins],
    methods: {
        ...mapActions(['addStockToWarehouse']),
        redirectPreviousUrl() {
            this.$router.back()
        },
        createLeadUrl() {
            this.$router.push('/pipeline/leads/add-lead');
        },
        exportExcell() {
            // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
            const dataToExport = [
                [
                    "ID",
                    "Supplier Name",
                    "User Name",
                    "Created At",
                    "Status"
                ],
            ];

            this.tableAllPurchaseOrders.forEach((v) => {
                dataToExport.push([
                    v.id,
                    v.supplierName,
                    v.userName,
                    v.createdAt,
                    v.status
                ]);
            });

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(dataToExport);

            /* Add the worksheet to the workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

            /* generate file and send to client */
            XLSX.writeFile(wb, `Export-Purchase-Orders-History-${moment().format('DD-MM-YYYY')}.xlsx`);
            this.showSuccessAlert("Data Successfully Exported")
        },
        getSalesFullmentsData(response) {
            if (response.status === 200) {
                this.tableSalesFullfillments = response.data.data.map(order => ({
                    key: order.id,
                    id: order.id,
                    sourceLocationName: order.request.sourceLocationName,
                    destinationLocationName: order.request.destinationLocationName,
                    expectedAt: moment(order.expectedAt).format("DD-MMM-YYYY"),
                    createdAt: moment(order.createdAt).format("DD-MMM-YYYY"),
                    statusLabel: order.statusLabel,
                    action: order
                }))
            } else {
                // console.log("Error | ", response)
            }
        },
        getBackOrdersFullmentsData(response) {
            if (response.status === 200) {
                this.tableBackordersFullfillments = response.data.data.map(order => ({
                    key: order.id,
                    id: order.id,
                    sourceLocationName: order.backOrder.sourceLocationName,
                    destinationLocationName: order.backOrder.destinationLocationName,
                    expectedAt: moment(order.expectedAt).format("DD-MMM-YYYY"),
                    createdAt: moment(order.createdAt).format("DD-MMM-YYYY"),
                    statusLabel: order.statusLabel,
                    action: order
                }))
            } else {
                // console.log("Error | ", response)
            }
        },
        async loadLead() {
            this.loading = true;
            const response = await this.$store.dispatch('pipeline/getLeads');
            this.loading = false;
            this.lead = response.data
        }
    },
    created() {
        if (this.loadLead) {
            this.loadLead()
        }
    }
}
</script>

<style scoped>
.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.spinner>>>.ant-spin-dot-item {
    background-color: #418a49;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>